import React from "react";
import { Form, Col } from "react-bootstrap";
import { TooltipIcon, DELETE_ICON } from "../../../../assets/js/image";
import "../../../Common/Tooltip/ToolTip.css";
import * as Constants from "../../../../constants/Constants";
import * as FieldConstants from "../../../../constants/FieldConstants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";

class ContactRecord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formDisabled: !(
        RolePermissionConstants.EDIT ===
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_CONTACTDETAILS,
          RolePermissionConstants.ALL
        )
      ),
    };
  }

  render() {
    const contactErrorFlag = this.props.addOtherContactErrorFlag;
    return (
      <Form.Row className="w-100p">
        {this.props.fields.map((fields, index) => {
          let field = {};
          const fieldName =
            this.props.role === "Other"
              ? this.props.role + " " + this.props.index + " " + fields.fieldId
              : this.props.role + " " + fields.fieldId;

          const showErrMsg = () =>
            this.props.showErrMsg(
              fieldName,
              fields.validateIndex,
              this.props.role === "Other"
                ? this.props.role +
                    " " +
                    this.props.index +
                    " " +
                    fields.fieldId
                : this.props.role + " " + fields.fieldId
            );
          const showErr = () =>
            this.props.showErr(
              fields.validateType,
              this.props.role === "Other"
                ? this.props.role +
                    " " +
                    this.props.index +
                    " " +
                    fields.fieldId
                : this.props.role + " " + fields.fieldId,
              this.props.contactRec[fields.fieldId]
            );
          switch (fields.fieldType) {
            case "text":
              field = (
                <Form.Group key={index} as={Col} md={fields.length}>
                  <Form.Label
                    id={fields.toolTipId}
                    className="tooltip compDetailsFormLabel"
                  >
                    {fields.fieldLabel}
                    {fields.required && (
                      <span className={Constants.REQUIRED}>*</span>
                    )}
                    <span className="tooltiptext">
                      <TooltipIcon></TooltipIcon>
                      {fields.toolTipText}
                    </span>
                  </Form.Label>
                  <Form.Control
                    required={
                      this.props.role === Constants.VENDOR_CONTACT_PRIMARY ||
                      this.props.role === Constants.VENDOR_CONTACT_TECHNICAL ||
                      this.props.role ===
                        Constants.VENDOR_CONTACT_CUSTOMER_SER ||
                      this.props.role === Constants.VENDOR_CONTACT_SHIPPING
                        ? fields.required
                        : false
                    }
                    disabled={this.state.formDisabled || this.props.disabled}
                    maxLength={(fields.fieldId === "phoneNumber" && 10).toString()}
                    id={fields.automationId}
                    automationid={fields.automationId}
                    data-id={fields.fieldId}
                    type={fields.fieldType}
                    placeholder={fields.placeHolder}
                    value={this.props.contactRec[fields.fieldId]}
                    onChange={async (e) => {
                      await this.props.onChange(e, this.props.index);
                      this.props.role === "Other"
                        ? contactErrorFlag(fieldName, () => showErrMsg())
                        : showErrMsg();
                    }}
                    onBlur={(e) => {
                      this.props.role === "Other"
                        ? contactErrorFlag(fieldName, () => showErrMsg())
                        : showErrMsg();
                    }}
                    style={{ padding: "5px" }}
                  />

                  {this.props.role === "Other" &&
                    this.props.contactRec?.error?.[fields.fieldId] &&
                    showErr()}
                  {this.props.role !== "Other" && showErr()}
                </Form.Group>
              );
              break;
            case "checkbox":
              field =
                this.props.role === Constants.VENDOR_CONTACT_PRIMARY ? (
                  <Form.Group key={index}>
                    <Form.Row>
                      <div className="m-left-10 m-top-10">
                        <Form.Label className="mr-3">
                          {fields.fieldLabel}
                        </Form.Label>
                        <Form.Check
                          disabled={this.state.formDisabled || this.props.disabled}
                          className="checkBoxLabel"
                          id={fields.fieldType + "-1"}
                          automationid={fields.fieldType + "-1"}
                          checked={this.props.isTechnicalChecked}
                          onChange={(event) => {
                            this.props.handleCheckBox(
                              Constants.VENDOR_CONTACT_TECHNICAL,
                              event
                            );
                            this.props.showErrMsg(
                              Constants.VENDOR_CONTACT_TECHNICAL +
                                " " +
                                fields.fieldId,
                              fields.validateIndex,
                              this.props.role + fields.fieldId
                            );
                          }}
                          inline
                          type="checkbox"
                          label={fields.fieldTechnical}
                        />
                        <Form.Check
                          disabled={this.state.formDisabled || this.props.disabled}
                          className="checkBoxLabel"
                          id={fields.fieldType + "-2"}
                          automationid={fields.fieldType + "-2"}
                          checked={this.props.isCustomerSerChecked}
                          onChange={(event) => {
                            this.props.handleCheckBox(
                              Constants.VENDOR_CONTACT_CUSTOMER_SER,
                              event
                            );
                            this.props.showErrMsg(
                              Constants.VENDOR_CONTACT_CUSTOMER_SER +
                                " " +
                                fields.fieldId,
                              fields.validateIndex,
                              this.props.role + fields.fieldId
                            );
                          }}
                          inline
                          type="checkbox"
                          label={fields.fieldCustomerService}
                        />
                        <Form.Check
                          disabled={this.state.formDisabled || this.props.disabled}
                          className="checkBoxLabel"
                          id={fields.fieldType + "-3"}
                          automationid={fields.fieldType + "-3"}
                          checked={this.props.isShippingChecked}
                          onChange={(event) => {
                            this.props.handleCheckBox(
                              Constants.VENDOR_CONTACT_SHIPPING,
                              event
                            );
                            this.props.showErrMsg(
                              Constants.VENDOR_CONTACT_SHIPPING +
                                " " +
                                fields.fieldId,
                              fields.validateIndex,
                              this.props.role + fields.fieldId
                            );
                          }}
                          inline
                          type="checkbox"
                          label={fields.fieldShipping}
                        />
                      </div>
                    </Form.Row>
                  </Form.Group>
                ) : (
                  <br key={index} />
                );
              break;
            case "select":
              field = (
                <Form.Group as={Col} md={3}>
                  <Form.Label className="tooltip compDetailsFormLabel">
                    {fields.fieldLabel}
                  </Form.Label>
                  <Form.Control
                    as="select"
                    id={fields.fieldId}
                    automationid={fields.fieldId}
                    disabled={this.state.formDisabled || this.props.disabled}
                  >
                    {fields.option.map((option) => {
                      let results = {};
                      results = (
                        <option name={option.optionName}>
                          {option.optionValue}
                        </option>
                      );
                      return results;
                    })}
                  </Form.Control>
                </Form.Group>
              );
              break;

            default:
              break;
          }
          return field;
        })}
        {this.props.delete === "Other" && (
          <Form.Row
            className="deleteAddress"
            id={"deleteButton" + this.props.index}
            onClick={() => !this.props.disabled && this.props.deleteContactHandler(this.props.index)}
          >
            <span 
              className={`deleteAnotherContact ${this.props.disabled ? 'text-muted' : ''}`}
              style={{
                cursor: this.props.disabled ? 'default' : 'pointer'
              }}
            >
              <DELETE_ICON
                style="deleteIcon"
                id={FieldConstants.deleteIconId}
              ></DELETE_ICON>
              {Constants.DELETE_CONATCT_LINK}
            </span>
          </Form.Row>
        )}
      </Form.Row>
    );
  }
}

export default ContactRecord;
